import styled from 'styled-components'

export const ClearFix = styled.div`
  clear: both;
`
